import '../styles/pages/main.scss'

console.log('Main Page');
